import React from 'react';
import { FilterColumnProps } from './types';
import { getColumnType, FilterColumnTypes } from './cfg';
import { BooleanFilter, CategoricalFilter, DateFilter, NumericalFilter, DurationFilter, PercentageFilter } from './filters';

export function ValueSelector(props: FilterColumnProps) {
  const standardColumnType = getColumnType(props.value.column_name)
  const columnType = props.columnType || standardColumnType
  
  // Render the appropriate filter component using proper JSX instead of function calls
  const renderFilter = () => {
    switch (columnType) {
      case FilterColumnTypes.BOOLEAN:
        return <BooleanFilter {...props} />;
      case FilterColumnTypes.CATEGORICAL:
        return <CategoricalFilter {...props} />;
      case FilterColumnTypes.DATE:
        return <DateFilter {...props} />;
      case FilterColumnTypes.NUMERICAL:
        return <NumericalFilter {...props} />;
      case FilterColumnTypes.DURATION:
        return <DurationFilter {...props} />;
      case FilterColumnTypes.BOOLEAN_NUMERICAL:
        return <BooleanFilter {...props} />;
      case FilterColumnTypes.PERCENTAGE:
        return <PercentageFilter {...props} />;
      default:
        return null;
    }
  };
  return (
    <div className="flex-1 min-w-0">
      {renderFilter()}
    </div>
  )
} 